import React, { useEffect, useMemo, useState } from "react";
import DataTable from "react-data-table-component";
import SpinnerCargando from "../SpinnerCargando";
import instanciaAxios from "../../../miscelaneo/instanciaAxios";
import { FaSearch } from "react-icons/fa";

const TablaCategoria = ({ setCategoriaSeleccionada, descripcion }) => {
  const [filtro, setFiltro] = useState("");
  const [categorias, setCategorias] = useState([]);
  const [cargando, setCargando] = useState(true);

  useEffect(() => {
    const cargarDatos = async () => {
      try {
        setCargando(true);
        const respuesta = await instanciaAxios.get("/miscelaneo/categoria");
        console.log("Respuesta de la API:", respuesta);
        if (respuesta.status === 200) {
          setCategorias(respuesta.data);
        } else {
          console.error("Datos inválidos o error en el formato recibido.");
          setCategorias([]);
        }
      } catch (error) {
        console.error("Error al cargar las categorías:", error);
        setCategorias([]);
      } finally {
        setCargando(false);
      }
    };

    cargarDatos();
  }, []);

  const datosFiltrados = useMemo(() => {
    if (!filtro) return categorias;
    return categorias.filter((categoria) =>
      (categoria.descripcion?.toLowerCase() || "").includes(filtro.toLowerCase())
    );
  }, [categorias, filtro]);

  const columns = [
    {
      name: "Descripción",
      selector: (row) => row.descripcion,
      sortable: true,
    }
  ];

  const handleRowClick = (categoria) => {
    setCategoriaSeleccionada(categoria);
  };

  if (cargando) return <SpinnerCargando />;

  if (categorias.length === 0) {
    return (
      <div className="text-center text-gray-500 mt-5">
        No se encontraron categorías.
      </div>
    );
  }

  return (
    <DataTable
      title={
        <>
          <h2 className="text-xl font-semibold text-center font-cascadia text-black">
            Categorías
          </h2>
          <p className="text-sm text-gray-500 text-center">
            {descripcion ? descripcion : null}
          </p>
        </>
      }
      columns={columns}
      data={datosFiltrados}
      pagination
      highlightOnHover
      onRowClicked={handleRowClick}
      dense
      subHeader
      subHeaderComponent={
        <div className="w-full relative">
          <FaSearch className="absolute right-3 top-1/2 transform -translate-y-1/2 text-color-secundario" />
          <input
            type="text"
            placeholder="Buscar categoría..."
            className="w-full border px-3 py-1 rounded-xl"
            value={filtro}
            onChange={(e) => setFiltro(e.target.value)}
          />
        </div>
      }
    />
  );
};

export default TablaCategoria;
